<template>
  <div>
    <v-dialog
      value="true"
      persistent
      max-width="500px"
    >
      <v-card>
        <v-card-title>
          <h3>Deactivate User Group</h3>
        </v-card-title>
        <v-card-text>
          <p>
            You have chosen to deactivate User Group <strong>{{ userGroup.userGroupName }}</strong>. If you continue, any users associated with this User Group will no longer be able to manage members on behalf of the Tracking Groups, Clients,
            or Cardholder Groups associated with this User Group. If this is your intent, click  <strong class="yes-remove-button">Yes, Deactivate</strong> and the User Group will be permanently disabled.
          </p>
          <p>
            Otherwise click <strong class="no-remove-button">No, Don't Deactivate</strong> and you will be returned to your task.
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="error" @click.stop="cancelDeactivation">No, Don't Deactivate</v-btn>
          <v-btn color="primary" @click.stop="removeSelectedUserGroup(userGroup)">Yes, Deactivate</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'manage-user-groups-deactivate-modal',
  props: {
    userGroup: Object
  },
  methods: {
    ...mapActions('manageUserGroups', ['deactivateUserGroup']),
    removeSelectedUserGroup(userGroup) {
      this.deactivateUserGroup(userGroup)
      this.cancelDeactivation()
    },
    cancelDeactivation() {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
  .yes-remove-button {
    color: $color-primary;
  }

  .no-remove-button {
    color: $color-danger;
  }
</style>
